import React from "react";
import { AlertCircle } from "lucide-react";

interface ErrorBannerProps {
  message: string;
  onDismiss: () => void;
}

export const ErrorBanner: React.FC<ErrorBannerProps> = ({ message, onDismiss }) => {
  return (
    <div className="fixed top-0 left-0 right-0 bg-red-50 border-b border-red-200 p-3 z-50 flex items-center gap-2 md:left-64">
      <AlertCircle className="w-4 h-4 text-red-600 flex-shrink-0" />
      <p className="text-sm text-red-600">{message}</p>
      <button
        onClick={onDismiss}
        className="ml-auto text-red-600 hover:text-red-700"
        aria-label="Dismiss error"
      >
        ×
      </button>
    </div>
  );
};